import script from "./orderPrint.vue?vue&type=script&setup=true&lang=ts"
export * from "./orderPrint.vue?vue&type=script&setup=true&lang=ts"

import "./orderPrint.vue?vue&type=style&index=0&id=39ef7629&lang=less&scoped=true"

import exportComponent from "D:\\projectLy\\2025伟本\\weben-les-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39ef7629"]])

export default __exports__